module.exports = __webpack_public_path__ + "img/daishenhe.7843d008.png";